import React, { Component } from "react";
import CustomizableTable from "./CustomizableTable";

import { RowCheckbox } from "../RowCheckbox";

const prependCheckbox = (data) =>
	data.map((item) => ({ ...item, selected: false }));

class LocalSelectTable extends Component {
	constructor(props, context) {
		super(props, context);

		this.addColumnHeader = this.addColumnHeader.bind(this);
		this.checkboxClicked = this.checkboxClicked.bind(this);
	}

	checkboxClicked(e, id, row) {
		if (this.props.onCheckboxChange) {
			this.props.onCheckboxChange(
				id,
				e.currentTarget.checked,
				row.original
			);
		}
	}

	addColumnHeader(columns) {
		return [
			{
				Header: ({ table }) => (
					<RowCheckbox
						checked={this.props.headerChecked || false}
						onClick={() => {
							// Pass filtered/visible data to the handler
							const visibleData = table
								? table
										.getFilteredRowModel()
										.rows.map((row) => row.original)
								: [];
							if (this.props.onHeaderCheckboxChange) {
								this.props.onHeaderCheckboxChange(visibleData);
							}
						}}
					/>
				),
				width: 40,
				accessor: "selected",
				sortable: false,
				resizable: false,
				filterable: false,
				unhidable: true,
				Cell: (row) => (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							height: "100%",
							maxHeight: 38,
						}}
					>
						<RowCheckbox
							checked={
								this.props.selectedItems &&
								this.props.selectedItems[row.original.id]
									? true
									: false
							}
							onChange={(e) =>
								this.checkboxClicked(e, row.original.id, row)
							}
						/>
					</div>
				),
			},
		].concat(columns);
	}

	render() {
		return (
			<CustomizableTable
				{...this.props}
				data={prependCheckbox(this.props.data)}
				columns={this.addColumnHeader(this.props.columns)}
			/>
		);
	}
}

export default LocalSelectTable;
